// src/modules/app-views/crm/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import OpportunityCollapse from './OpportunityCollapse';
import ContactCollapse from './ContactCollapse';
import { getStorageModuleItem, setStorageModuleItem } from 'stores/module';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const STORAGE_KEY = 'crmDocCollapseKeys';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const RecordTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [collapseKeys, setCollapseKeys] = useState(
    () => getStorageModuleItem(STORAGE_KEY) || {}
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleCollapseChange = useCallback((key, activeKeys) => {
    setCollapseKeys(prev => {
      const next = { ...prev, [key]: activeKeys };
      setStorageModuleItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      <OpportunityCollapse
        activeKey={collapseKeys.opportunity || []}
        onCollapseChange={keys => handleCollapseChange('opportunity', keys)}
      />
      <ContactCollapse
        activeKey={collapseKeys.entity || []}
        onCollapseChange={keys => handleCollapseChange('entity', keys)}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default RecordTab;
